import { AND_DELIMITER, OR_DELIMITER } from './constants';

/*
  Input:
  ======
  {
    "Xbox One": {
      "field": "TAG",
      "key": "c3.device.model",
      "op": "eq",
      "value": "Xbox One",
      "display": "Xbox One"
    },
    "COMEDY-M": {
      "field": "TAG",
      "key": "channel",
      "op": "eq",
      "value": "COMEDY-M",
      "display": "COMEDY-M"
    }
  }

  Output: When flexible is false
  ==============================
  {
    "name": "Xbox One__AND__COMEDY-M",
    "rule": [
      [
        {
          "field": "TAG",
          "key": "c3.device.model",
          "op": "eq",
          "value": "Xbox One",
          "display": "Xbox One"
        }
      ],
      [
        {
          "field": "TAG",
          "key": "channel",
          "op": "eq",
          "value": "COMEDY-M",
          "display": "COMEDY-M"
        }
      ]
    ]
  }
*/
const ALL_TRAFFIC = 'Filters';

const getGroupKey = (filter) => {
  const fieldKey = filter.originalField ? 'originalField' : 'field';
  return filter[fieldKey] === 'TAG' ? `${filter[fieldKey]}_${filter.key}` : filter[fieldKey];
};

const getRuleDisplay = (rule) => (rule.op === 'not eq' ? `NOT ${rule.display}` : rule.display);

const filtersMapToRule = (filtersMap) => {
  const groupKeys = new Set();
  const filters = Object.values(filtersMap);
  const $groupKey = Symbol('groupKey');

  filters.forEach((filter) => {
    // attach a key for grouping filters
    const key = getGroupKey(filter);
    filter[$groupKey] = key; // eslint-disable-line
    groupKeys.add(key);
  });

  const rules = Array.from(groupKeys).map((key) => filters.filter((f) => f[$groupKey] === key));
  const andRules = rules.map((orRules) => orRules.map((r) => getRuleDisplay(r)).join(OR_DELIMITER));
  const ruleName = andRules.join(AND_DELIMITER);

  return {
    name: ruleName || ALL_TRAFFIC,
    rule: rules,
  };
};

/* eslint-disable no-underscore-dangle */
const getFlexibleFilterFromRules = (filtersMap) => {
  const sortedFilters = Object.values(filtersMap).sort(
    (rule1, rule2) => rule1._order > rule2._order,
  );
  const withoutOrder = sortedFilters.filter((r) => r._order === undefined);
  const unorderedRules = Object.fromEntries(withoutOrder.map((r) => [r.display, r]));

  const withOrder = sortedFilters.filter((r) => r._order !== undefined);
  const orders = Array.from(new Set(withOrder.map((r) => r._order)));
  const rules = orders.map((order) => withOrder.filter((r) => r._order === order));
  let name = rules
    .map((orRules) => orRules.map((rule) => getRuleDisplay(rule)).join(OR_DELIMITER))
    .join(AND_DELIMITER);

  const collatedFilter = filtersMapToRule(unorderedRules);
  rules.push(...collatedFilter.rule);
  if (collatedFilter.rule.length !== 0) {
    name = name ? `${name}${AND_DELIMITER}${collatedFilter.name}` : collatedFilter.name;
  }

  return {
    name: name || ALL_TRAFFIC,
    rule: rules,
  };
};
/* eslint-enable no-underscore-dangle */

const getFilterFromRules = (filtersMap, flexible = false) =>
  flexible ? getFlexibleFilterFromRules(filtersMap) : filtersMapToRule(filtersMap);

export default getFilterFromRules;
